module.exports = __webpack_public_path__ + "cbaaa3b3b2edc129db8ca3cfe68762a1.png";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/content/assets/ui-revamp/megingjord-center-logo.png
// module id = 29
// module chunks = 0